import React from 'react';
import './StyledPageNotFound.css';
import pageNotFoundImg from 'src/assets/page_not_found.png';
import { i18nService } from 'src/services/i18n.service';

/**
 * PageNotFound is a React functional component that renders an error message
 * indicating that a user was not found.
 * Note: There is no hebrew translation since the user has not been found and no language is set.
 */
const PageNotFound: React.FC = () => {
  return (
    <div className="page-not-found-container">
      <div className="page-not-found-illustration">
        <img src={pageNotFoundImg} alt="User not found" />
      </div>
      <p className="page-not-found-message">
        {i18nService.translate('pageNotFound.line1')}
        <br />
        {i18nService.translate('pageNotFound.line2')}
      </p>
      <p className="page-not-found-instruction-safety">
        {i18nService.translate('pageNotFound.line3')}{' '}
        <a
          href="https://achieved.io/operator"
          target="_blank"
          rel="noreferrer"
          className="page-not-found-safety-link"
        >
          {i18nService.translate('pageNotFound.safety')}
        </a>
      </p>
    </div>
  );
};

export default PageNotFound;
